var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"filElem",attrs:{"type":"file"},on:{"change":_vm.afterRead}})}
var staticRenderFns = []

export { render, staticRenderFns }